<section id="projects" class="projects-section py-24 relative overflow-hidden">
  <div class="projects-bg"></div>

  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
    <div class="text-center mb-12">
      <span class="section-badge">Our Work</span>
      <h2 class="text-4xl sm:text-5xl font-bold mt-4 mb-4">
        Projects We've <span class="gradient-text">Built</span>
      </h2>
      <p class="text-slate-600 max-w-2xl mx-auto text-lg">
        Products developed by Trieon Technologies — client delivery and company initiatives across healthcare, HR, and finance.
      </p>
      <div class="section-underline"></div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      @for (project of projects(); track project.slug) {
        <article class="project-card" [style.--accent]="project.color">
          <a
            class="project-header"
            [attr.data-tone]="project.category.toLowerCase()"
            [routerLink]="['/products', project.slug]"
            [attr.aria-label]="'View ' + project.title + ' details'"
          >
            @if (project.preview) {
              <img
                [src]="project.preview"
                [alt]="project.title + ' preview'"
                class="project-preview"
              />
            } @else {
              <div class="project-icon-wrap">
                <div class="project-icon" [style.color]="project.color">
                  <i class="pi text-3xl" [class]="project.icon"></i>
                </div>
              </div>
            }
            <span class="project-category">{{ project.category }}</span>
          </a>

          <div class="project-body">
            <h3>
              <a [routerLink]="['/products', project.slug]">{{ project.title }}</a>
            </h3>
            <p class="project-desc">{{ project.description }}</p>

            <div class="project-tags">
              @for (tag of project.stack; track tag) {
                <span class="proj-tag">{{ tag }}</span>
              }
            </div>

            <div class="project-actions">
              <a class="project-details" [routerLink]="['/products', project.slug]">
                View details
                <i class="pi pi-arrow-right"></i>
              </a>
            </div>
          </div>
        </article>
      }
    </div>
  </div>
</section>
